// extracted by mini-css-extract-plugin
export default {"container":"lga-z","mediaElement":"mga-z","close":"nga-z"};